import { APICall } from "@/config/NetworkUtility";
import { logApiError } from "@/services/apiErrorLogger";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ==============================
// THUNK
// ==============================
export const getAccountTypeDropdownList = createAsyncThunk(
  "accountType/getAccountTypeDropdownList",
  async (_, { rejectWithValue }) => {
    try {
      const url = "v1/NavigationSetup/GetAccountTypeDropdownList";

      const result = await APICall("get", {}, url);

      if (result?.statuscode === 200 || result?.statuscode === 201) {
        return result?.data?.accountTypeList || [];
      }

      return rejectWithValue(result);
    } catch (error) {
      logApiError(error, {
        source: "account types",
        endpoint: "getAccountTypeDropdownList",
      });

      return rejectWithValue(error);
    }
  },
);

// ==============================
// INITIAL STATE
// ==============================
const initialState = {
  accountTypes: [],
  loading: false,
  error: null,
};

// ==============================
// SLICE
// ==============================
const accountTypeSlice = createSlice({
  name: "accountType",
  initialState,
  reducers: {
    clearAccountTypes: (state) => {
      state.accountTypes = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // GET ACCOUNT TYPES
      .addCase(getAccountTypeDropdownList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getAccountTypeDropdownList.fulfilled, (state, action) => {
        state.loading = false;
        state.accountTypes = action.payload;
      })

      .addCase(getAccountTypeDropdownList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// ==============================
// EXPORTS
// ==============================
export const { clearAccountTypes } = accountTypeSlice.actions;

export default accountTypeSlice.reducer;
